import { useState, useRef, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleDown, faSortDown } from '@fortawesome/free-solid-svg-icons'
import { CSVLink } from 'react-csv'
import { buildClientCsvFile } from './ClientCsvFileBuilder'
import { getCurrentDate } from '../../../helpers/formatDate'

const ClientDownloadButton = ({
  downloadData,
  isDownloadDataFetching,
  clientData,
  startDate,
  endDate
}) => {
  const [showDropdown, setShowDropdown] = useState(false)
  const dropdownRef = useRef(null)
  //   const origin = window.location.origin;

  //   const handlePdfDownload = () => {
  //     buildSettlementPdf(data, canSeeAnnulledDocumentsTab, origin);
  //     setShowDropdown(false);
  //   };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="" ref={dropdownRef}>
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="btn btn-default download-report-button-settlements"
      >
        <FontAwesomeIcon icon={faArrowCircleDown} className="icon-download" />
        Descargar Reporte
        <span className="download-report-button-drop-divider"></span>
        <FontAwesomeIcon icon={faSortDown} className="icon-dropdown" />
      </button>

      {showDropdown && (
        <div className="dropdown-menu-drop-settlements" style={{ height: 40 }}>
          {/* El style en el div es temporal, es para que no se vea feo el dropdown mientras no esta el PDF */}
          {/* <a />  //////////TBD: Descargable de PDF
            href="#"
            className="dropdown-item-drop"
            onClick={(e) => {
              e.preventDefault()
              console.log('reporte de pdf.')
              //   handlePdfDownload();
            }}
          >
            Perfil 360° del cliente (.pdf)
          </a> */}
          <CSVLink
            className="dropdown-item-drop"
            data={buildClientCsvFile(downloadData, clientData, startDate, endDate)}
            filename={`Actividades_${clientData.customer_name_db_ref.replace(/\s/g, '')}_${getCurrentDate()}.csv`}
            onClick={() => setShowDropdown(false)}
          >
            Actividades del cliente (.csv)
          </CSVLink>
        </div>
      )}
    </div>
  )
}

export default ClientDownloadButton
